import { createApp } from "vue";
import { createRouter, createWebHashHistory } from "vue-router";
import PrimeVue from "primevue/config";
import ToastService from "primevue/toastservice";
import Aura from "@primeuix/themes/aura";
import "primeicons/primeicons.css";

import App from "./App.vue";
import Login from "./views/Login.vue";
import Dashboard from "./views/Dashboard.vue";
import "./style.css";

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    { path: "/", component: Dashboard, name: "dashboard" },
    // Deep link target for the "new review" email notification.
    // Same Dashboard component; the view picks up `:id` and opens the drawer.
    { path: "/reviews/:id(\\d+)", component: Dashboard, name: "review-deep-link" },
    // Manager-only analytics. Lazy-loaded so AG Grid stays out of the main
    // (Dashboard) bundle; the view itself redirects non-managers, and the
    // backend serves only the personal slice to them regardless.
    {
      path: "/analytics",
      component: () => import("./views/Analytics.vue"),
      name: "analytics",
    },
    { path: "/login", component: Login, name: "login" },
  ],
});

const app = createApp(App);
app.use(router);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      // The Aura preset assumes a `.app-dark` class for dark mode; we
      // explicitly disable that auto-binding so we stay in the light theme.
      darkModeSelector: ".never-dark",
    },
  },
  ripple: false,
});
app.use(ToastService);
app.mount("#app");
